import { render, staticRenderFns } from "./FeaturedItem.vue?vue&type=template&id=049017a8&scoped=true"
import script from "./FeaturedItem.vue?vue&type=script&lang=ts"
export * from "./FeaturedItem.vue?vue&type=script&lang=ts"
import style0 from "./FeaturedItem.vue?vue&type=style&index=0&id=049017a8&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049017a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src400484917/src/search.myaileron.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('049017a8')) {
      api.createRecord('049017a8', component.options)
    } else {
      api.reload('049017a8', component.options)
    }
    module.hot.accept("./FeaturedItem.vue?vue&type=template&id=049017a8&scoped=true", function () {
      api.rerender('049017a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/search/FeaturedItem.vue"
export default component.exports